@if (isFooterVisible) {
  <footer>
    <div class="container text-center text-md-left">
      <div class="row justify-content-md-center format-footer">
        @if (brandInfo.brand !== 'Lambo') {
          <div class="col-md-6 footer-group-logo">
            <div class="p-4 footer-logo">
              @if (footer?.logo?.url) {
                <img aria-hidden="true" [src]="footer?.logo?.url ? footer.logo.url : ''" [alt]="footer?.logo?.alt" />
              }
              @if (dealerName && brandInfo.brand !== 'Motorrad') {
                <div class="nav-dealer">{{ dealerName }}</div>
              }
            </div>
          </div>
        }
        <hr class="clearfix w-100 d-md-none" />
        <div class="col-md-6 footer-group-contact-us">
          <div class="font-weight-bold text-uppercase mt-5 mb-4" tabindex="0" role="heading">
            <strong>Contact Us</strong>
          </div>
          <ul class="list-unstyled">
            <li>
              <div tabindex="0"><mdb-icon fas icon="phone"></mdb-icon>{{ branding.cs_phone_number }}</div>
            </li>
            <li>
              <div tabindex="0">{{ branding.cs_email }}</div>
            </li>
            <li>
              <div aria-label="Hours of operation." tabindex="0" class="hours-of-operation">
                <div class="" tabindex="0" [innerHtml]="footer?.hours ? getHtml(footer.hours, false) : ''"></div>
              </div>
            </li>
          </ul>
          @if (brandInfo.brand === 'Porsche') {
            <hr class="footer-rule"/>
          }
        </div>
      </div>
    </div>
    <div class="footer-copyright text-center p-4">
      <div class="row justify-content-center">
        <div class="row footer-links">
          <div >
            @if (useLegalFolder) {
              <a id="footerTermsConditionsLink" tabindex="0" role="link" target="_blank" rel="noopener noreferrer" [attr.aria-label]="('FOOTER.TERMS_CONDITIONS' | translate) + ' ' + ('FOOTER.OPEN_NEW_TAB' | translate)" [attr.href]="buildHref(['/legal/terms-and-conditions'], { lang: thisLang })">{{ 'FOOTER.TERMS_CONDITIONS' | translate }}</a>
            }
            @if (!useLegalFolder) {
              <a id="footerTermsConditionsLink" tabindex="0" role="link" target="_blank" rel="noopener noreferrer" [attr.aria-label]="('FOOTER.TERMS_CONDITIONS' | translate) + ' ' + ('FOOTER.OPEN_NEW_TAB' | translate)" [attr.href]="buildHref(['/terms-and-conditions'], { lang: thisLang })">{{ 'FOOTER.TERMS_CONDITIONS' | translate }}</a>
            }
          </div>
          <div >
            @if (useLegalFolder) {
              <a id="footerPrivacyPolicyLink" tabindex="0" role="link" target="_blank" rel="noopener noreferrer" [attr.aria-label]="('FOOTER.PRIVACY' | translate) + ' ' + ('FOOTER.OPEN_NEW_TAB' | translate)" [attr.href]="buildHref(['/legal/privacy-policy'], { lang: thisLang })">{{ 'FOOTER.PRIVACY' | translate }}</a>
            }
            @if (!useLegalFolder) {
              <a id="footerPrivacyPolicyLink" tabindex="0" role="link" target="_blank" rel="noopener noreferrer" [attr.aria-label]="('FOOTER.PRIVACY' | translate) + ' ' + ('FOOTER.OPEN_NEW_TAB' | translate)" [attr.href]="buildHref(['/privacy-policy'], { lang: thisLang })">{{ 'FOOTER.PRIVACY' | translate }}</a>
            }
          </div>
          @if (isGMBrand) {
            <div>
              <a id="footerCaliforniaPrivacyLink" tabindex="0" role="link" aria-label="California Privacy Rights (opens in a new tab)" (click)="showInterstitial()">{{ 'FOOTER.PRIVACY_CALIFORNIA' | translate }}</a>
            </div>
          }
          <div>
            @if (useLegalFolder) {
              <a id="footerAccessibilityLink" tabindex="0" role="link" target="_blank" rel="noopener noreferrer" [attr.aria-label]="('FOOTER.ACCESSIBILITY' | translate) + ' ' + ('FOOTER.OPEN_NEW_TAB' | translate)" [attr.href]="buildHref(['/legal/accessibility'], { lang: thisLang })">{{ 'FOOTER.ACCESSIBILITY' | translate }}</a>
            }
            @if (!useLegalFolder) {
              <a id="footerAccessibilityLink" tabindex="0" role="link" target="_blank" rel="noopener noreferrer" [attr.aria-label]="('FOOTER.ACCESSIBILITY' | translate) + ' ' + ('FOOTER.OPEN_NEW_TAB' | translate)" [attr.href]="buildHref(['/accessibility'], { lang: thisLang })">{{ 'FOOTER.ACCESSIBILITY' | translate }}</a>
            }
          </div>
          <div>
            @if (brandInfo.brand === 'REV') {
              <a id="footerAboutUsLink" tabindex="0" role="link" target="_blank" rel="noopener noreferrer" [attr.aria-label]="('FOOTER.ABOUT_US' | translate) + ' ' + ('FOOTER.OPEN_NEW_TAB' | translate)" [attr.href]="buildHref(['/about-us'], { lang: thisLang })">{{ 'FOOTER.ABOUT_US' | translate }}</a>
            }
          </div>
        </div>
      </div>
      <div><span tabindex="0" class="rights-reserved" [innerHtml]="footer?.copyright_statement ? checkYear(getHtml(footer.copyright_statement, false)) : ''"></span></div>
      <div id="version" class="footer-version">v 10.3.0</div>

      <div class="siteseal"><span id="siteseal"></span></div>
    </div>
    @if (brandInfo.brand ==='Porsche') {
      <div class="p-5 porsche-bottom footer-logo"><img style="width:200px; padding-top:50px;" aria-hidden="true" src="https://images.prismic.io/sgidigital-dev/Z1xh7ZbqstJ98fIi_porsche_logotypeWht.png?auto=format,compress" alt="Porsche logo in white letters spelling out the word Porsche" class="ng-star-inserted"></div>
    }
  </footer>
}
